// extracted by mini-css-extract-plugin
export default {"my-orders":"myorder_my-orders__xkOFn","totalContainer":"myorder_totalContainer__DNFNa","tableContainer":"myorder_tableContainer__SFjcy"};